var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStartup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#96B659",
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 425.2 425.2",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M218.407,88.8h12c4.4,0,8-3.6,8-8c0-4.4-3.6-8-8-8h-12c-4.4,0-8,3.6-8,8C210.407,85.2,214.007,88.8,218.407,88.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.407,152.8c-22,0-40,18-40,40s18,40,40,40s40-18,40-40S232.407,152.8,210.407,152.8z M210.407,216.8 c-13.2,0-24-10.8-24-24s10.8-24,24-24s24,10.8,24,24S223.607,216.8,210.407,216.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.807,415.6l-12-65.6c-3.2-17.2-13.6-31.2-28.4-39.2l-22.8-12.4c7.2-27.2,11.2-55.6,11.2-84v-10.8 c0-60.8-18.8-118.8-54.4-168.8l-18-24.8c-4.4-6.4-11.6-10-19.6-10c-7.6,0-14.8,3.6-19.6,10l-18,24.8 c-35.2,49.2-54.8,109.2-54.8,169.2v10.8c0,28.8,4,57.6,11.6,85.6l-19.2,10.4c-14.8,8-25.2,22-28.4,39.2l-12,65.2 c-0.4,3.2,0.8,6.8,4,8.4c1.2,0.8,2.8,1.2,4,1.2c2,0,3.6-0.8,5.2-2l33.6-28.8c12.8-11.2,29.6-17.2,46.8-17.2h14.4 c0.4,0,0.8,0,1.2,0c0.8,0,2,0,2.8,0h8v26c0,12,10,22,22,22s22-10,22-22v-26.4h4h0.4c1.2,0.4,2.4,0.8,3.6,0.8h18.8 c17.2,0,34,6,46.8,17.2l33.6,28.8c1.6,1.2,3.2,2,5.2,2c1.2,0,2.8-0.4,4-1.2C353.607,422.4,355.207,419.2,354.807,415.6z M106.807,382l-16.4,14.4l7.6-43.2c2.4-12.4,9.6-22.4,20.4-28l16-8.8l9.6,32c1.6,5.2,4,9.6,7.2,13.6 C134.807,364.4,119.207,371.2,106.807,382z M218.407,402.8c0,3.2-2.8,6-6,6s-6-2.8-6-6v-84c0-3.2,2.8-6,6-6s6,2.8,6,6V402.8z M238.407,360.4h-4v-41.6c0-12-10-22-22-22s-22,10-22,22v42h-8c-10.8,0-20-7.2-23.2-17.2l-12-40.4c-8.4-28.8-12.8-58.4-12.8-88.4 V204c0-39.6,8.8-79.2,25.6-115.2h30.4c4.4,0,8-3.6,8-8c0-4.4-3.6-8-8-8h-22c5.2-10,11.2-19.2,18-28.4l18-24.8 c1.6-2,4-3.2,6.4-3.2c2.8,0,4.8,1.2,6.4,3.2l18,24.8c33.6,46.8,51.2,102,51.2,159.2v10.8c0,30-4.4,60-12.8,88.4l-12,40.4 C258.407,353.6,249.207,360.4,238.407,360.4z M318.407,382.4c-13.6-11.6-30.8-18.8-48.8-20.8c3.2-4,5.6-8.4,7.2-13.6l10-33.6 l19.6,10.8c10.4,5.6,18,16,20.4,28l8,43.2L318.407,382.4z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStartup);
export default __webpack_public_path__ + "static/media/startup.b24c701dd9cb146e519efc0ef7a301d7.svg";
export { ForwardRef as ReactComponent };